/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StatementOutputDto { 
    id?: number;
    transactionId?: string | null;
    transactionDate?: string;
    amount?: number;
    transactionType?: string | null;
    accountActivity?: string | null;
    balance?: number;
    status?: string | null;
}

